import { Liker } from '../../../types/Liker';
import { UserInformation } from '../../UserInformation/UserInformation';

interface PostLikersProps {
  likers: Liker[];
}

export const PostLikers = ({ likers }: PostLikersProps) => {
  return (
    <div className="scrollbar-none overflow-y-auto p-6">
      {likers.map(({ _id, firstName, lastName, nickname, avatar }) => {
        const avatarUrl = avatar?.url ?? '';
        const informationDetails = [firstName ?? '', lastName ?? ''];

        return (
          <UserInformation
            key={_id}
            avatarUrl={avatarUrl}
            className="mb-4"
            informationDetails={informationDetails}
            informationSeparator=" "
            nickname={nickname}
          />
        );
      })}
    </div>
  );
};
